import { render, staticRenderFns } from "./Tu.vue?vue&type=template&id=3f30dd4e&"
import script from "./Tu.vue?vue&type=script&lang=js&"
export * from "./Tu.vue?vue&type=script&lang=js&"
import style0 from "./Tu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports